import React, { useState, useEffect } from 'react';
import { Button, Modal, Input, List, Tag, message } from 'antd'; 
import './ProjectSelect.less';
import { projectSelectApi } from './ProjectSelectApi';
import { hexFromStr, invertColor } from '@/utils/S';
import { CloseOutlined } from '@ant-design/icons';
import { Project } from '@/project/model'; 
 

const statusColors = ['#248dea', '#df6005', '#0ea913', '#979797'];
const statusTexts = ['待开始', '进行中', '已完成', '已废弃'];

const ProjectSelect: React.FC<{defaultProjectName, onSelect: (projectId: number) => void }> = ({ defaultProjectName, onSelect }) => {
  const [selectedProject, setSelectedProject] = useState<Project | null>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [projects, setProjects] = useState<Project[]>([]);
  const [loading, setLoading] = useState(false);

  // 打开弹框时调用接口获取项目数据
  useEffect(() => {
    if (isModalVisible) {
      fetchProjects();
    }
  }, [isModalVisible]);
 

  const fetchProjects = async () => {
    setLoading(true);
    try {
      const data = await projectSelectApi.queryProjects(searchText, new Date()); // 使用查询接口
      setProjects(data);
    } catch (error) {
      message.error('获取项目列表失败');
    } finally {
      setLoading(false);
    }
  };

  // 过滤和排序后的项目列表
  const filteredProjects = projects
    .filter((project) =>
      project.name.toLowerCase().includes(searchText.toLowerCase())
    )
    .sort((a, b) => new Date(b.submitTime).getTime() - new Date(a.submitTime).getTime());

  const handleSelect = (project: Project) => {
    setSelectedProject(project);
    setIsModalVisible(false);
    onSelect(project.id);
  };

  return (
    <div className="project-select">
      <div className="select-text">
        {selectedProject || defaultProjectName ? (
          <div className="project-tag" style={{backgroundColor:hexFromStr(selectedProject.name), color:invertColor(hexFromStr(selectedProject.name))}}>
            <span className="project-name" onClick={() => setIsModalVisible(true)}>{ defaultProjectName ? defaultProjectName:selectedProject.name }</span>
            <CloseOutlined className="close-btn" onClick={() => {
              setSelectedProject(null);
              onSelect(null); 
            }} /> 
          </div>
        ) : (
          <span onClick={() => setIsModalVisible(true)}>选择项目归属</span>
        )}
      </div>
      <Modal
        title="选择项目"
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        className='project-select-modal'
      >
        <Input
          placeholder="搜索项目"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
        <div className='result-desc'>{filteredProjects.length}条结果：</div>
        <List
              className='list-area'
              itemLayout="horizontal"
              loading={loading}
              dataSource={filteredProjects}
              renderItem={(project) => (
                <List.Item onClick={() => handleSelect(project)} className="project-item">
                  <div className="project-info">
                    <span className="project-name">{project.name}</span>
                    <span className="director-name">{project.directorName}</span>
                  </div>
                  <Tag className="project-status" color={statusColors[project.status]}>
                    {statusTexts[project.status]}
                  </Tag>
                </List.Item>
              )}
            />
      </Modal>
    </div>
  );
};

export default ProjectSelect;